export enum ModalType {
  Closed = 'closed',
  Other = 'other',
}
